module.exports = __webpack_public_path__ + "img/1579617481.b8e63c41.jpg";